/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateCompanyRequest
 */
export interface CreateOrUpdateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyRequest
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyRequest
     */
    entityType?: string;
}

/**
 * Check if a given object implements the CreateOrUpdateCompanyRequest interface.
 */
export function instanceOfCreateOrUpdateCompanyRequest(value: object): value is CreateOrUpdateCompanyRequest {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    return true;
}

export function CreateOrUpdateCompanyRequestFromJSON(json: any): CreateOrUpdateCompanyRequest {
    return CreateOrUpdateCompanyRequestFromJSONTyped(json, false);
}

export function CreateOrUpdateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'],
        'name': json['name'],
        'taxId': json['taxId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function CreateOrUpdateCompanyRequestToJSON(json: any): CreateOrUpdateCompanyRequest {
    return CreateOrUpdateCompanyRequestToJSONTyped(json, false);
}

export function CreateOrUpdateCompanyRequestToJSONTyped(value?: CreateOrUpdateCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'name': value['name'],
        'taxId': value['taxId'],
        'entityType': value['entityType'],
    };
}

